import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { NgxPermissionsObject, NgxPermissionsService } from 'ngx-permissions';
import { BaseSelectors } from './../state/base/base.selectors';

@Injectable({
    providedIn: 'root',
})
export class RulesService {
    private permissionsService = inject(NgxPermissionsService);
    private store = inject(Store);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Ignored with eslint-interactive on 2026-02-26
    private allRules: any = {
        ROLE_NET_USER: [],
        ROLE_NET_OWNER: ['send_documentation__menu_send-visible', 'self-pay-stat-visible'],
    };

    public setRules(): void {
        const roles = this.store.selectSnapshot(BaseSelectors.getUser)?.roles;
        if (roles === null) {
            return;
        }
        if (roles) {
            const userPermissions: string[] = [];
            roles.map(el => {
                if (this.allRules[el]) {
                    userPermissions.push(...this.allRules[el]);
                }
            });
            this.permissionsService.loadPermissions(userPermissions);
        }
    }

    public getAllRules(): NgxPermissionsObject {
        return this.permissionsService.getPermissions();
    }
}
